const menuRouter = [
    /**
     * 仓库管理
     **/
    {
        path: '/stock/warehouse',
        meta: { title: '仓库管理' },
        component: () => import('@/views/page/stock/warehouse'),
        used: true,
    },
    {
        path: '/stock/localtion',
        meta: { title: '库位管理' },
        component: () => import('@/views/page/stock/localtion'),
        used: true,
    },
    {
        path: '/stock/productstart',
        meta: { title: '期初导入' },
        component: () => import('@/views/page/stock/productstart'),
        used: true,
    },
    {
        path: '/stock/intobill',
        meta: { title: '物资入库' },
        component: () => import('@/views/page/stock/intobill'),
        used: true,
    },
    {
        path: '/stock/intobill/mxInfo',
        meta: { title: '物资入库登记' },
        component: () => import('@/views/page/stock/intobill/mxInfo'),
        used: true,
    },
    {
        path: '/stock/intoretbill',
        meta: { title: '物资入库退出' },
        component: () => import('@/views/page/stock/intoretbill'),
        used: true,
    },
    {
        path: '/stock/requisitionbill',
        meta: { title: '物资领用' },
        component: () => import('@/views/page/stock/requisitionbill'),
        used: true,
    },
    {
        path: '/stock/outbill',
        meta: { title: '物资出库' },
        component: () => import('@/views/page/stock/outbill'),
        used: true,
    },
    {
        path: '/stock/outretbill',
        meta: { title: '物资出库退入' },
        component: () => import('@/views/page/stock/outretbill'),
        used: true,
    },
    {
        path: '/stock/transferbill',
        meta: { title: '物资调拨单' },
        component: () => import('@/views/page/stock/transferbill'),
        used: true,
    },
    {
        path: '/stock/borrowbill',
        meta: { title: '物资借入单' },
        component: () => import('@/views/page/stock/borrowbill'),
        used: true,
    },
    {
        path: '/stock/borrowretbill',
        meta: { title: '物资借入还出单' },
        component: () => import('@/views/page/stock/borrowretbill'),
        used: true,
    },
    {
        path: '/stock/lendbill',
        meta: { title: '物资借出单' },
        component: () => import('@/views/page/stock/lendbill'),
        used: true,
    },
    {
        path: '/stock/lendretbill',
        meta: { title: '物资归还单' },
        component: () => import('@/views/page/stock/lendretbill'),
        used: true,
    },
    {
        path: '/stock/lendnoretun',
        meta: { title: '未归还查询' },
        component: () => import('@/views/page/stock/lendnoreturn'),
        used: true,
    },
    {
        path: '/stock/checkbill',
        meta: { title: '物资盘点单' },
        component: () => import('@/views/page/stock/checkbill'),
        used: true,
    },
    {
        path: '/stock/breakagebill',
        meta: { title: '物资报废单' },
        component: () => import('@/views/page/stock/breakagebill'),
        used: true,
    },
]

export default menuRouter
